module.exports = __webpack_public_path__ + "img/p-two-step-10.09c61e92.png";